module.exports = __webpack_public_path__ + "img/V2.76253f7c.jpg";